import { makeStyles, Theme, createStyles } from '@material-ui/core';
import React, { FC } from 'react';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import { ContactHQInfoData } from '../ContactsPage.types';

export type ContactHqInfoProps = { data: ContactHQInfoData };

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    title: {
      fontWeight: 600,
      fontSize: '2rem',
      margin: 0,
    },
    contentRoot: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    name: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    position: {
      fontWeight: 300,
    },
  }),
);

const ContactHqInfo: FC<ContactHqInfoProps> = ({ data }) => {
  const t = useTranslateWithFallback();
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <h3 className={classes.title}>{data.title}</h3>
      <div className={classes.contentRoot}>
        <span className={classes.name}>{data.name}</span>
        <span>{data.address}</span>
        {data.emails.map((email, index) => (
          <a href={`mailto:${email}`} key={index}>
            {email}
          </a>
        ))}
        <span>{data.comment}</span>
        <span>
          {`${t('common/regNo')}: `}
          {data.regNo}
        </span>
        <span>
          {`${t('common/taxNo')}: `}
          {data.vatNo}
        </span>
      </div>
    </section>
  );
};

export default ContactHqInfo;
